import { render } from "./ArticlesEditor.vue?vue&type=template&id=f3c18bce&ts=true"
import script from "./ArticlesEditor.vue?vue&type=script&lang=ts"
export * from "./ArticlesEditor.vue?vue&type=script&lang=ts"

import "./ArticlesEditor.vue?vue&type=style&index=0&id=f3c18bce&lang=css"
/* custom blocks */
import block0 from "./ArticlesEditor.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__